// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"df86d792","526":"87a42175","783":"f258932c","833":"f43a07f4"}[chunkId] + ".chunk.js";
};